<div class="d-flex flex-column align-items-center justify-content-center h-100">
	<div class="app-loader">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>
